import React from "react";
import { Text } from "@fluentui/react-components";

interface IErrorMessageProps {
    errorMsg: string | React.ReactNode | undefined;
}

export default function ErrorMessage(props: IErrorMessageProps) {
    return (
        <div className="flex justify-center items-center w-screen h-screen">
            <Text
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-(--colorNeutralForeground1)"
                weight="bold"
                size={500}
            >
                {props.errorMsg}
            </Text>
        </div>
    );
}
